<template>

  <form-edit-activity :form-type="FORM_TYPE" ref="formEditor"
                      :mode="mode"
                      :entity-id="entityId"
                      @form-created="formCreated"
                      :custom-add="true"
                      @saved="helloWorld"
  >
  </form-edit-activity>
</template>

<script>
import Activity from "@/activity/Activity";
import PermissionsSet from "@/server/PermissionsSet";
import Rpc from "@/Rpc";
import FormsListActivity from "@/activity/templates/layouts/forms/FormsListActivity";
import FormsLoader from "@/components/forms/FormsLoader";

import FormEditActivity from "@/activity/templates/layouts/forms/FormEditActivity";
import FormMixin from "@/components/forms/customizations/mixins/FormMixin";
import ReachInput from "@/components/inputs/ReachInput";
import MultiSelectToProductInSeason from "@/server/com/silkplm/model/plm/MultiSelectToProductInSeason";


const FORM_TYPE = MultiSelectToProductInSeason;

export default {
  name: "MultiSelectToProductInSeasonEditor",
  components: {ReachInput, FormMixin, FormEditActivity, FormsListActivity},
  permission: () => FormsLoader.formPermission(FORM_TYPE),

  props: {
    entityId: {default: null},
    mode: {type: String, default: "NEW"},
    context: {default: null},
    selectedProducts: {default : null}
  },

  created() {
  },

  async mounted() {
  },

  methods: {
    ...Activity.methods,

    getTitle() {
      return $tr('multiSelect.title.select','Select the season and sub-season for which products should be added');
    },

    async canClose() {
      return this.$refs.formEditor.canClose();
    },

    /** @type {FormModel} form */
    async formCreated(form) {
      this.form = form;
    },

    async helloWorld() {
      let seasonId = this.form.fields.seasonId.value;
      let subSeasonId = this.form.fields.subSeasonId.value;
      await Rpc.plm.services.ProductService.addMultiProductsToSeasonAndSubSeason(this.selectedProducts, seasonId, subSeasonId)
    }
  },

  data: function () {
    return {
      FORM_TYPE,
      /** @type {FormModel} */
      form: null,
      readOnly: true,
      permissions: new PermissionsSet(),
      formConfig: FormsLoader.detectFormConfig(FORM_TYPE),
      formId: FormsLoader.detectFormConfig(FORM_TYPE).formId,
    }
  }
}
</script>
